// // UserDetailsModal.jsx
// import React from 'react';
// import { User, Building2, Hash, TabletSmartphone, Trash2, X, Fingerprint, Download } from 'lucide-react';

// const UserDetailsModal = ({ isOpen, onClose, user, onUnenrollAll, onUnenrollDevice, onExportTemplate, formatDate, getStatusBadge }) => {
//   if (!isOpen || !user) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
//       <div className="bg-richblue-950 border border-blue-700/50 rounded-2xl w-full sm:max-w-4xl max-h-[92vh] overflow-y-auto sm:mb-0 mb-[30px]" onClick={(e) => e.stopPropagation()}>
//         <div className="sticky top-0 flex items-center justify-between p-5 border-b bg-richblue-950 border-blue-800/40">
//           <h2 className="flex items-center gap-2 text-xl font-bold text-white">
//             <User className="w-5 h-5 text-blue-400" /> User Details
//           </h2>
//           <button onClick={onClose} className="p-2 transition-colors rounded-lg hover:bg-blue-600/20">
//             <X className="w-5 h-5 text-blue-400" />
//           </button>
//         </div>

//         <div className="p-5 space-y-5">
//           <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
//             {/* Basic Information */}
//             <div className="p-4 border bg-richblue-900 rounded-xl border-blue-800/40">
//               <h3 className="flex items-center gap-2 mb-3 text-sm font-semibold text-blue-300">
//                 <Hash className="w-4 h-4" /> Basic Information
//               </h3>
//               <div className="space-y-2 text-sm">
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Name</span>
//                   <span className="text-right text-white truncate">{user.user_name}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Email</span>
//                   <span className="text-right text-white truncate">{user.user_email}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Phone</span>
//                   <span className="text-right text-white truncate">{user.user_phone}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Department</span>
//                   <span className="text-right text-white truncate">{user.user_department}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">ID</span>
//                   <span className="text-right text-white truncate">{user.user_roll}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Work Offset</span>
//                   <span className="text-right text-white truncate">{user?.workoffset}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">View TZ</span>
//                   <span className="text-right text-white truncate">{user?.viewtimezone}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="text-blue-400/60">Shift</span>
//                   <span className="text-right text-green-400">{user?.shift_start} – {user?.shift_end}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="text-blue-400/60">Status</span>
//                   <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusBadge(user.status)}`}>
//                     {user.status}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Organization Details */}
//             <div className="p-4 border bg-richblue-900 rounded-xl border-blue-800/40">
//               <h3 className="flex items-center gap-2 mb-3 text-sm font-semibold text-blue-300">
//                 <Building2 className="w-4 h-4" /> Organization Details
//               </h3>
//               <div className="space-y-2 text-sm">
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Organization</span>
//                   <span className="text-right text-white truncate">{user.org_Id?.org_name}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Org Email</span>
//                   <span className="text-right text-white truncate">{user.org_Id?.org_email}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">License Key</span>
//                   <span className="text-right text-white truncate">{user.org_Id?.license_key}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Total Devices</span>
//                   <span className="text-right text-white truncate">{user.org_Id?.total_devices}</span>
//                 </div>
//                 <div className="flex justify-between gap-2">
//                   <span className="flex-shrink-0 text-blue-400/60">Total Users</span>
//                   <span className="text-right text-white truncate">{user.org_Id?.total_users}</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Fingerprint Templates Section */}
//           <div className="p-4 border bg-richblue-900 rounded-xl border-blue-800/40">
//             <h3 className="flex items-center gap-2 mb-3 text-sm font-semibold text-blue-300">
//               <Fingerprint className="w-4 h-4" /> Fingerprint Templates ({user.Templates?.length || 0})
//             </h3>
//             {user.Templates && user.Templates.length > 0 ? (
//               <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
//                 {user.Templates.map((template, index) => (
//                   <div key={template._id || index} className="p-3 border rounded-lg bg-richblue-800 border-blue-800/30">
//                     <div className="flex items-center justify-between mb-2">
//                       <div className="flex items-center gap-2">
//                         <Fingerprint className="w-4 h-4 text-blue-400" />
//                         <h4 className="text-sm font-semibold text-white">{template.Type || 'Unknown Type'}</h4>
//                       </div>
//                       <span className="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-green-900/50 text-green-300">
//                         Registered
//                       </span>
//                     </div>
//                     <div className="space-y-1 text-xs">
//                       {/* <div>
//                         <p className="text-blue-400/60">Template ID</p>
//                         <p className="text-gray-300 font-mono text-[11px] break-all">{template._id}</p>
//                       </div> */}
//                       {template.Image && (
//                         <div>
//                           <p className="text-blue-400/60">Image Data</p>
//                           <p className="text-gray-400 truncate">{template.Image.substring(0, 50)}...</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="p-4 text-center border rounded-lg bg-yellow-900/20 border-yellow-700/50">
//                 <Fingerprint className="w-8 h-8 mx-auto mb-2 text-yellow-500 opacity-50" />
//                 <p className="text-sm text-yellow-300">No fingerprint templates registered</p>
//                 <p className="mt-1 text-xs text-yellow-400/70">User needs to register fingerprints on a device first</p>
//               </div>
//             )}
//           </div>

//           {/* Manager Information */}
//           <div className="p-4 border bg-richblue-900 rounded-xl border-blue-800/40">
//             <h3 className="flex items-center gap-2 mb-3 text-sm font-semibold text-blue-300">
//               <User className="w-4 h-4" /> Manager Information
//             </h3>
//             <div className="grid grid-cols-2 gap-3 text-sm">
//               <div>
//                 <p className="text-xs text-blue-400/60 mb-0.5">Manager Name</p>
//                 <p className="text-white truncate">{user.manager_Id?.manager_name || 'N/A'}</p>
//               </div>
//               <div>
//                 <p className="text-xs text-blue-400/60 mb-0.5">Manager Email</p>
//                 <p className="text-white truncate">{user.manager_Id?.manager_email || 'N/A'}</p>
//               </div>
//               <div>
//                 <p className="text-xs text-blue-400/60 mb-0.5">Manager ID</p>
//                 <p className="text-white truncate font-mono text-[11px]">{user.manager_Id?._id || 'N/A'}</p>
//               </div>
//               <div>
//                 <p className="text-xs text-blue-400/60 mb-0.5">Manager Status</p>
//                 <p className={user.manager_Id?.status ? 'text-green-400' : 'text-red-400'}>
//                   {user.manager_Id?.status ? 'ACTIVE' : 'INACTIVE'}
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Assigned Devices */}
//           <div className="p-4 border bg-richblue-900 rounded-xl border-blue-800/40">
//             <div className="flex items-center justify-between mb-3">
//               <h3 className="flex items-center gap-2 text-sm font-semibold text-blue-300">
//                 <TabletSmartphone className="w-4 h-4" /> Assigned Devices ({user.devices?.length || 0})
//               </h3>
//               {user.devices && user.devices.length > 0 && (
//                 <button
//                   onClick={onUnenrollAll}
//                   className="px-3 py-1 text-xs transition bg-red-600 rounded-lg hover:bg-red-700"
//                 >
//                   Unenroll All
//                 </button>
//               )}
//             </div>
//             {user.devices && user.devices.length > 0 ? (
//               <div className="space-y-3">
//                 {user.devices.map((deviceAssignment) => (
//                   <div key={deviceAssignment._id} className="p-3 border rounded-lg bg-richblue-800 border-blue-800/30">
//                     <div className="flex items-start justify-between gap-2 mb-2">
//                       <h4 className="text-sm font-semibold text-white truncate">
//                         {deviceAssignment.device?.device_name}
//                       </h4>
//                       <div className="flex items-center flex-shrink-0 gap-2">
//                         <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
//                           deviceAssignment.enrollment_status === 'ACTIVE' 
//                             ? 'bg-green-900/50 text-green-300' 
//                             : 'bg-yellow-900/50 text-yellow-300'
//                         }`}>
//                           {deviceAssignment.enrollment_status}
//                         </span>
//                         <button
//                           onClick={() => onUnenrollDevice(deviceAssignment.device, deviceAssignment.enrollment_id)}
//                           className="p-1.5 rounded-md bg-red-600/20 hover:bg-red-600/40 transition"
//                           title="Unenroll from device"
//                         >
//                           <Trash2 className="w-3.5 h-3.5 text-red-400" />
//                         </button>
//                         <button
//                           onClick={() => onExportTemplate({
//                             userId: user._id,
//                             deviceId: deviceAssignment.device?._id,
//                             fingerId: deviceAssignment.enrollment_id // Assuming you have finger_id in the deviceAssignment
//                           })}
//                           className="p-1.5 rounded-md bg-blue-600/20 hover:bg-blue-600/40 transition"
//                           title="Export fingerprint template"
//                         >
//                           <Download className="w-3.5 h-3.5 text-blue-400" />
//                         </button>
//                       </div>
//                     </div>
//                     <div className="grid grid-cols-2 gap-2 text-xs sm:grid-cols-3">
//                       <div>
//                         <p className="text-blue-400/60">Device Code</p>
//                         <p className="text-white truncate">{deviceAssignment.device?.device_code}</p>
//                       </div>
//                       <div>
//                         <p className="text-blue-400/60">Location</p>
//                         <p className="text-white truncate">{deviceAssignment.device?.device_location}</p>
//                       </div>
//                       <div>
//                         <p className="text-blue-400/60">Firmware</p>
//                         <p className="text-white truncate">{deviceAssignment.device?.device_firmware_version}</p>
//                       </div>
//                       <div>
//                         <p className="text-blue-400/60">Enrollment ID</p>
//                         <p className="text-white truncate font-mono text-[11px]">{deviceAssignment.enrollment_id}</p>
//                       </div>
//                       <div>
//                         <p className="text-blue-400/60">Finger ID</p>
//                         <p className="text-white truncate font-mono text-[11px]">{deviceAssignment.finger_id || 'N/A'}</p>
//                       </div>
//                       <div>
//                         <p className="text-blue-400/60">Enrolled At</p>
//                         <p className="text-white truncate">{formatDate(deviceAssignment.enrollment_at)}</p>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="p-4 text-center border rounded-lg bg-gray-900/20 border-gray-700/50">
//                 <TabletSmartphone className="w-8 h-8 mx-auto mb-2 text-gray-500 opacity-50" />
//                 <p className="text-sm text-gray-400">No devices assigned</p>
//               </div>
//             )}
//           </div>

//           {/* Metadata */}
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
//             <div className="p-4 border bg-richblue-900 rounded-xl border-blue-800/40">
//               <h3 className="mb-1 text-xs font-semibold text-blue-300">Created</h3>
//               <p className="text-xs text-gray-400">By: {user.createdBy || 'N/A'}</p>
//               <p className="text-xs text-gray-400">At: {formatDate(user.createdAt)}</p>
//             </div>
//             <div className="p-4 border bg-richblue-900 rounded-xl border-blue-800/40">
//               <h3 className="mb-1 text-xs font-semibold text-blue-300">Last Updated</h3>
//               <p className="text-xs text-gray-400">By: {user.updatedBy || 'N/A'}</p>
//               <p className="text-xs text-gray-400">At: {formatDate(user.updatedAt)}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserDetailsModal;



// UserDetailsModal.jsx
import React from 'react';
import { User, Building2, Hash, TabletSmartphone, Trash2, X, Fingerprint, Download } from 'lucide-react';

const UserDetailsModal = ({ isOpen, onClose, user, onUnenrollAll, onUnenrollDevice, onExportTemplate, formatDate, getStatusBadge, theme }) => {
  if (!isOpen || !user) return null;

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgHeader = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgSection = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  const bgCard = isDark ? 'bg-richblue-800' : 'bg-gray-100';
  const bgNoData = isDark ? 'bg-yellow-900/20 border-yellow-700/50' : 'bg-yellow-50 border-yellow-300';
  const bgNoDevices = isDark ? 'bg-gray-900/20 border-gray-700/50' : 'bg-gray-50 border-gray-300';
  
  const borderColor = isDark ? 'border-blue-700/50' : 'border-gray-300';
  const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const borderSection = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const borderCard = isDark ? 'border-blue-800/30' : 'border-gray-200';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
  const textMuted = isDark ? 'text-blue-400/60' : 'text-gray-500';
  const textGray = isDark ? 'text-gray-400' : 'text-gray-500';
  const textGreen = isDark ? 'text-green-400' : 'text-green-600';
  const textRed = isDark ? 'text-red-400' : 'text-red-600';
  const textYellow = isDark ? 'text-yellow-300' : 'text-yellow-700';
  
  const hoverBg = isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100';
  const buttonUnenroll = isDark ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600';
  
  const badgeActive = isDark ? 'bg-green-900/50 text-green-300' : 'bg-green-100 text-green-700';
  const badgeInactive = isDark ? 'bg-yellow-900/50 text-yellow-300' : 'bg-yellow-100 text-yellow-700';
  
  const iconColor = isDark ? 'text-blue-400' : 'text-blue-600';

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`} onClick={onClose}>
      <div className={`${bgModal} border ${borderColor} rounded-2xl w-full sm:max-w-4xl max-h-[92vh] overflow-y-auto sm:mb-0 mb-[30px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
        <div className={`sticky top-0 flex items-center justify-between p-5 border-b ${bgHeader} ${borderLight}`}>
          <h2 className={`flex items-center gap-2 text-xl font-bold ${textPrimary}`}>
            <User className={`w-5 h-5 ${iconColor}`} /> User Details
          </h2>
          <button onClick={onClose} className={`p-2 transition-colors rounded-lg ${hoverBg}`}>
            <X className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-500'}`} />
          </button>
        </div>

        <div className="p-5 space-y-5">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {/* Basic Information */}
            <div className={`p-4 border ${bgSection} ${borderSection} rounded-xl transition-colors duration-300`}>
              <h3 className={`flex items-center gap-2 mb-3 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                <Hash className="w-4 h-4" /> Basic Information
              </h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Name</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.user_name}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Email</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.user_email}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Phone</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.user_phone}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Department</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.user_department}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>ID</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.user_roll}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Work Offset</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user?.workoffset}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>View TZ</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user?.viewtimezone}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Shift</span>
                  <span className="text-right text-green-400">{user?.shift_start} – {user?.shift_end}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Status</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusBadge(user.status)}`}>
                    {user.status}
                  </span>
                </div>
              </div>
            </div>

            {/* Organization Details */}
            <div className={`p-4 border ${bgSection} ${borderSection} rounded-xl transition-colors duration-300`}>
              <h3 className={`flex items-center gap-2 mb-3 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                <Building2 className="w-4 h-4" /> Organization Details
              </h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Organization</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.org_Id?.org_name}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Org Email</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.org_Id?.org_email}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>License Key</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.org_Id?.license_key}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Total Devices</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.org_Id?.total_devices}</span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className={`flex-shrink-0 ${textMuted}`}>Total Users</span>
                  <span className={`text-right ${textPrimary} truncate`}>{user.org_Id?.total_users}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Fingerprint Templates Section */}
          <div className={`p-4 border ${bgSection} ${borderSection} rounded-xl transition-colors duration-300`}>
            <h3 className={`flex items-center gap-2 mb-3 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
              <Fingerprint className="w-4 h-4" /> Fingerprint Templates ({user.Templates?.length || 0})
            </h3>
            {user.Templates && user.Templates.length > 0 ? (
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {user.Templates.map((template, index) => (
                  <div key={template._id || index} className={`p-3 border rounded-lg ${bgCard} ${borderCard} transition-colors duration-300`}>
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <Fingerprint className={`w-4 h-4 ${iconColor}`} />
                        <h4 className={`text-sm font-semibold ${textPrimary}`}>{template.Type || 'Unknown Type'}</h4>
                      </div>
                      <span className={`px-2 py-0.5 text-[10px] font-semibold rounded-full ${isDark ? 'bg-green-900/50 text-green-300' : 'bg-green-100 text-green-700'}`}>
                        Registered
                      </span>
                    </div>
                    <div className="space-y-1 text-xs">
                      {template.Image && (
                        <div>
                          <p className={textMuted}>Image Data</p>
                          <p className={`${isDark ? 'text-gray-400' : 'text-gray-600'} truncate`}>{template.Image.substring(0, 50)}...</p>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={`p-4 text-center rounded-lg ${bgNoData} border transition-colors duration-300`}>
                <Fingerprint className={`w-8 h-8 mx-auto mb-2 ${isDark ? 'text-yellow-500 opacity-50' : 'text-yellow-600 opacity-50'}`} />
                <p className={`text-sm ${textYellow}`}>No fingerprint templates registered</p>
                <p className={`text-xs ${isDark ? 'text-yellow-400/70' : 'text-yellow-600/70'} mt-1`}>User needs to register fingerprints on a device first</p>
              </div>
            )}
          </div>

          {/* Manager Information */}
          <div className={`p-4 border ${bgSection} ${borderSection} rounded-xl transition-colors duration-300`}>
            <h3 className={`flex items-center gap-2 mb-3 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
              <User className="w-4 h-4" /> Manager Information
            </h3>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p className={`text-xs ${textMuted} mb-0.5`}>Manager Name</p>
                <p className={`${textPrimary} truncate`}>{user.manager_Id?.manager_name || 'N/A'}</p>
              </div>
              <div>
                <p className={`text-xs ${textMuted} mb-0.5`}>Manager Email</p>
                <p className={`${textPrimary} truncate`}>{user.manager_Id?.manager_email || 'N/A'}</p>
              </div>
              <div>
                <p className={`text-xs ${textMuted} mb-0.5`}>Manager ID</p>
                <p className={`${textPrimary} truncate font-mono text-[11px]`}>{user.manager_Id?._id || 'N/A'}</p>
              </div>
              <div>
                <p className={`text-xs ${textMuted} mb-0.5`}>Manager Status</p>
                <p className={user.manager_Id?.status ? textGreen : textRed}>
                  {user.manager_Id?.status ? 'ACTIVE' : 'INACTIVE'}
                </p>
              </div>
            </div>
          </div>

          {/* Assigned Devices */}
          <div className={`p-4 border ${bgSection} ${borderSection} rounded-xl transition-colors duration-300`}>
            <div className="flex items-center justify-between mb-3">
              <h3 className={`flex items-center gap-2 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                <TabletSmartphone className="w-4 h-4" /> Assigned Devices ({user.devices?.length || 0})
              </h3>
              {user.devices && user.devices.length > 0 && (
                <button
                  onClick={onUnenrollAll}
                  className={`px-3 py-1 text-xs text-white transition rounded-lg ${buttonUnenroll}`}
                >
                  Unenroll All
                </button>
              )}
            </div>
            {user.devices && user.devices.length > 0 ? (
              <div className="space-y-3">
                {user.devices.map((deviceAssignment) => (
                  <div key={deviceAssignment._id} className={`p-3 border rounded-lg ${bgCard} ${borderCard} transition-colors duration-300`}>
                    <div className="flex items-start justify-between gap-2 mb-2">
                      <h4 className={`text-sm font-semibold ${textPrimary} truncate`}>
                        {deviceAssignment.device?.device_name}
                      </h4>
                      <div className="flex items-center flex-shrink-0 gap-2">
                        <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                          deviceAssignment.enrollment_status === 'ACTIVE' 
                            ? badgeActive
                            : badgeInactive
                        }`}>
                          {deviceAssignment.enrollment_status}
                        </span>
                        <button
                          onClick={() => onUnenrollDevice(deviceAssignment.device, deviceAssignment.enrollment_id)}
                          className={`p-1.5 rounded-md ${isDark ? 'bg-red-600/20 hover:bg-red-600/40' : 'bg-red-100 hover:bg-red-200'} transition`}
                          title="Unenroll from device"
                        >
                          <Trash2 className={`w-3.5 h-3.5 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
                        </button>
                        <button
                          onClick={() => onExportTemplate({
                            userId: user._id,
                            deviceId: deviceAssignment.device?._id,
                            fingerId: deviceAssignment.enrollment_id
                          })}
                          className={`p-1.5 rounded-md ${isDark ? 'bg-blue-600/20 hover:bg-blue-600/40' : 'bg-blue-100/20 hover:bg-blue-200/30'} transition`}
                          title="Export fingerprint template"
                        >
                          <Download className={`w-3.5 h-3.5 ${iconColor}`} />
                        </button>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-xs sm:grid-cols-3">
                      <div>
                        <p className={textMuted}>Device Code</p>
                        <p className={`${textPrimary} truncate`}>{deviceAssignment.device?.device_code}</p>
                      </div>
                      <div>
                        <p className={textMuted}>Location</p>
                        <p className={`${textPrimary} truncate`}>{deviceAssignment.device?.device_location}</p>
                      </div>
                      <div>
                        <p className={textMuted}>Firmware</p>
                        <p className={`${textPrimary} truncate`}>{deviceAssignment.device?.device_firmware_version}</p>
                      </div>
                      <div>
                        <p className={textMuted}>Enrollment ID</p>
                        <p className={`${textPrimary} truncate font-mono text-[11px]`}>{deviceAssignment.enrollment_id}</p>
                      </div>
                      <div>
                        <p className={textMuted}>Finger ID</p>
                        <p className={`${textPrimary} truncate font-mono text-[11px]`}>{deviceAssignment.finger_id || 'N/A'}</p>
                      </div>
                      <div>
                        <p className={textMuted}>Enrolled At</p>
                        <p className={`${textPrimary} truncate`}>{formatDate(deviceAssignment.enrollment_at)}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={`p-4 text-center rounded-lg ${bgNoDevices} border transition-colors duration-300`}>
                <TabletSmartphone className={`w-8 h-8 mx-auto mb-2 ${isDark ? 'text-gray-500 opacity-50' : 'text-gray-400 opacity-50'}`} />
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>No devices assigned</p>
              </div>
            )}
          </div>

          {/* Metadata */}
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <div className={`p-4 border ${bgSection} ${borderSection} rounded-xl transition-colors duration-300`}>
              <h3 className={`mb-1 text-xs font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>Created</h3>
              <p className={`text-xs ${textGray}`}>By: {user.createdBy || 'N/A'}</p>
              <p className={`text-xs ${textGray}`}>At: {formatDate(user.createdAt)}</p>
            </div>
            <div className={`p-4 border ${bgSection} ${borderSection} rounded-xl transition-colors duration-300`}>
              <h3 className={`mb-1 text-xs font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>Last Updated</h3>
              <p className={`text-xs ${textGray}`}>By: {user.updatedBy || 'N/A'}</p>
              <p className={`text-xs ${textGray}`}>At: {formatDate(user.updatedAt)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsModal;
